import { toast } from "react-toastify"

const extractErrorMessages = (error) => {
  const data = error?.response?.data

  if (Array.isArray(data?.errors)) {
    return data.errors
  }

  // fallback (network / unexpected)
  if (error?.message) {
    return [error.message]
  }

  return []
}

const HandleFail = async (call_back) => {
  try {
    await call_back()
  } catch (error) {
    console.log(error)
    let messages = extractErrorMessages(error)
    if (messages.length === 0) {
      toast.error("An unknown error occurred")
    } else {
      messages.forEach((msg) => toast.error(msg))
    }
  }
}

export default HandleFail
